var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1871_15462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9099 6.96742L8.99986 9.87742L6.08986 6.96742C5.79736 6.67492 5.32486 6.67492 5.03236 6.96742C4.73986 7.25992 4.73986 7.73242 5.03236 8.02492L8.47486 11.4674C8.76736 11.7599 9.23986 11.7599 9.53236 11.4674L12.9749 8.02492C13.2674 7.73242 13.2674 7.25992 12.9749 6.96742C12.6824 6.68242 12.2024 6.67492 11.9099 6.96742Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1871_15462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLess);
export default __webpack_public_path__ + "static/media/less.9988a75653d6aeb4b6504ebdfc782937.svg";
export { ForwardRef as ReactComponent };